<template>
    <div style="width: 100%;">
        <div v-if="!data.isWarn" style="display: inline-block;"
             :class="{'history-row': (formInfo.showHistoryTag !== 0 && data.showHistory)}"
        >
            <el-tooltip v-if="formInfo.showHistoryTag === 2 && data.showHistory" :content="data.historyValue">
                <span>{{ data.value }}</span>
            </el-tooltip>
            <span v-else :style="data.style">
                {{ data.value }}
            </span>
        </div>
        <span v-else>
    <div class="warning-box">{{ data.value }}</div>
    <el-popover
        placement="top"
        width="350"
        title="预警说明"
        trigger="click">
      <p style="padding:0px 16px 12px 12px;margin: 0">
        <el-form label-width="84px" style="display: flex;flex-wrap: wrap;justify-content: space-between"
                 class="viewFormWrapper">
          <el-form-item label="预警项：">
            <span class="activeColor">{{ data.warnItemsName }}</span>
          </el-form-item>
          <el-form-item label="预警说明：">
            <span class="activeColor">{{ data.warnItemsContent }}</span>
          </el-form-item>
        </el-form>
      </p>
      <div style="text-align: center; margin: 0;padding: 12px">
        <el-button type="primary" size="mini" @click="routerToDetail(data.warnItemsDetailId)">查看详情</el-button>
      </div>
      <el-icon name="tishi" :width="'18px'" :height="'18px'"
                class="site-sidebar__menu-icon"></el-icon>
    </el-popover>
      </span>
    </div>
</template>

<script>
export default {
    name: "warnRecordItem",
    props: {
        data: {
            type: Object,
            required: true
        },
        formInfo: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {}
    },
    methods: {
        routerToDetail(id) {
            this.$router.push({
                name: "warn_record_detail",
                query: {
                    id:id || '',
                    angleType:this.angleType,
                },
            });
            // this.$emit('routerToDetail', {
            //     name: "warn_record_detail",
            //     query: {
            //         id: id || '',
            //         angleType: this.angleType,
            //     },
            // })
        },
    }
}
</script>

<style lang="less" scoped>
.warning-box {
    display: inline-block;
    background: #ffc7ce;
    color: #ff0000;
    line-height: 22px
}

.history-row {
    background-color: rgb(246,154,35);
}
</style>
